import * as React from 'react';
import {
  ArticleHeading1,
  UIHeading1,
  UIText1,
  IconChevronUpSmall16,
  IconChevronDownSmall16,
  ArticleParagraph2,
  Button,
  UIHeading4,
  ArticleHeading2,
  UIHeading2,
} from '@cian/ui-kit';
import { IconFunctionalSuccess16 } from '@cian/ui-kit-design-tokens/icons';

import * as styles from './styles.css';
import { ConditionalWrapper } from '@cian/conditional-component';

export interface IProfitItemLayout {
  isDesktop: boolean;

  title: string;
  description: string;
  wrapperDescription: string;
  income: string;

  percentForYear?: string;
  details?: string;
  detailsItems: { title: string; value: string }[];

  additionalInfo: string[];

  showDetails: boolean;
  onClick: () => void;

  buttonText: string;
  onButtonClick: () => void;

  modalComponent?: React.ReactNode;
}

export const ProfitItemLayout: React.FC<IProfitItemLayout> = ({
  title,
  description,
  wrapperDescription,
  income,
  percentForYear,
  details,
  detailsItems,
  showDetails,
  onClick,
  additionalInfo,
  buttonText,
  onButtonClick,
  modalComponent,
  isDesktop,
}) => {
  return (
    <>
      <div className={styles['container']}>
        <div className={styles['title']}>
          <ConditionalWrapper if={isDesktop} ThenComponent={ArticleHeading1} ElseComponent={ArticleHeading2}>
            {title}
          </ConditionalWrapper>
          <UIText1>{description}</UIText1>
        </div>

        <div className={styles['wrapper']}>
          <div className={styles['wrapper-heading']}>
            <UIText1 color="gray60_100">{wrapperDescription}</UIText1>
            <ConditionalWrapper if={isDesktop} ThenComponent={UIHeading1} ElseComponent={UIHeading2}>
              {income}
            </ConditionalWrapper>
            {percentForYear && <UIHeading4>{percentForYear}</UIHeading4>}
          </div>

          <div onClick={onClick} className={styles['details-button']}>
            <UIText1 color="primary_100">Подробнее</UIText1>

            {showDetails ? (
              <IconChevronUpSmall16 color="primary_100" />
            ) : (
              <IconChevronDownSmall16 color="primary_100" />
            )}
          </div>

          {showDetails && (
            <div className={styles['details']}>
              <UIText1>{details}</UIText1>

              <ul className={styles['details-list']}>
                {detailsItems.map(({ title, value }, index) => (
                  <li key={title + index}>
                    <ArticleParagraph2 color="gray60_100">{title}</ArticleParagraph2>
                    <UIText1 color="black_100">{value}</UIText1>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>

        <ul className={styles['additional']}>
          {additionalInfo.map((info, index) => (
            <li key={info + index}>
              <IconFunctionalSuccess16 color="primary_100" />

              <UIText1>{info}</UIText1>
            </li>
          ))}
        </ul>

        <Button size="L" onClick={onButtonClick} fullWidth={!isDesktop}>
          {buttonText}
        </Button>
      </div>

      {modalComponent}
    </>
  );
};
